import React, { useState } from 'react';
import './EAPreSavePage.css';

// Get the correct API URL based on environment
const API_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://samplesphere.soave.ink/api'
    : 'http://localhost:5000/api');

const EAPreSavePage = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    country: '',
    consent: false,
    newsletter: false
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);

  const countries = [
    'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 
    'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 
    'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 
    'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia', 'Cameroon', 'Canada', 'Central African Republic', 'Chad', 
    'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 
    'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 
    'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon', 'Gambia', 'Georgia', 
    'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 
    'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 
    'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kosovo', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 
    'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi', 'Malaysia', 
    'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 
    'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 
    'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan', 
    'Palau', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 
    'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 
    'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 
    'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan', 
    'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 
    'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 
    'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 
    'Vatican City', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
  ];

  

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    // Validate required fields
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.country) {
      setMessage('Please fill in all required fields');
      setLoading(false);
      return;
    }

    if (!formData.consent) {
      setMessage('Please accept the terms and conditions');
      setLoading(false);
      return;
    }

    try {
      const fullName = `${formData.firstName} ${formData.lastName}`;

      const response = await fetch(`${API_URL}/subscribers/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: fullName,
          email: formData.email,
          country: formData.country,
          genre: 'Electronic', // Default genre for pre-save
          termsAccepted: formData.consent,
          marketingConsent: formData.consent,
          signupSource: 'ea-pre-save',
          preSave: true,
          eaPreSave: true,
          newsletter: formData.newsletter
        })
      });

      const data = await response.json();

      if (data.success) {
        setSuccess(true);
        // Use the message from the backend (handles both new signups and existing subscribers)
        setMessage(data.message || 'Successfully signed up! Check your email for the discount code.');
        
        // Reset form
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          country: '',
          consent: false,
          newsletter: false
        });
      } else {
        setSuccess(false);
        setMessage(data.message || 'Failed to sign up. Please try again.');
      }
    } catch (error) {
      console.error('Pre-save signup error:', error);
      setMessage('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ea-presave-page">
      <div className="form-container">
        {/* Left Panel */}
        <div 
          className="left-panel"
          style={{
            backgroundImage: `url(https://s3.us-east-1.amazonaws.com/gembo.media1/social/THNDERZ+Hard+Techno+Sample+Pack+Mobile+Banner.jpg)`
          }}
        >
          <div className="logo-section">
            <div className="logo">
              <img src="https://samplesphere.com/cdn/shop/files/Logo.png" alt="Samplesphere" className="logo-img" />
            </div>
          </div>
          <div className="left-content">
            <h1 className="left-heading">Pre Save Now and Get 10% Off!</h1>
            <p className="left-text">200+ Drum, Vocal, Sound, Effects both one shots & loops. Together with 50+ crafted Serum Presets, ready to dial in for you next production. Sign up and get a 15% discount when the pack launches on February 18th!</p>
          </div>
        </div>

        {/* Right Panel */}
        <div className="right-panel">
          <h2 className="form-heading">Sign up for Pre-Save</h2>
          
          {message && (
            <div className={success ? 'success-message' : 'error-message'}>
              {message}
            </div>
          )}
          
          {!success && (
            <form onSubmit={handleSubmit} className="presave-form">
              <p className="required-note">Fields marked with <span className="required">*</span> are required</p>
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="firstName">First name<span className="required">*</span></label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    placeholder="John"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Last name<span className="required">*</span></label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    placeholder="Carter"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="email">Email<span className="required">*</span></label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Email"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="country">Country of residence<span className="required">*</span></label>
                <select
                  id="country"
                  name="country"
                  value={formData.country}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select a country</option>
                  {countries.map(country => (
                    <option key={country} value={country}>{country}</option>
                  ))}
                </select>
              </div>

              <div className="checkbox-group">
                <input
                  type="checkbox"
                  id="consent"
                  name="consent"
                  checked={formData.consent}
                  onChange={handleInputChange}
                  required
                />
                <label htmlFor="consent" className="checkbox-label">
                  <span className="presave-checkbox-text">I agree to the</span>{' '}
                  <span 
                    className="terms-link presave-terms-link" 
                    onClick={(e) => {
                      e.preventDefault();
                      setShowTermsModal(true);
                    }}
                  >
                    terms of service
                  </span>
                  <span className="required">*</span>
                </label>
              </div>

              <div className="checkbox-group">
                <input
                  type="checkbox"
                  id="newsletter"
                  name="newsletter"
                  checked={formData.newsletter}
                  onChange={handleInputChange}
                />
                <label htmlFor="newsletter" className="checkbox-label">
                  <span className="presave-checkbox-text">Sign up for our newsletter to hear about our news and get exclusive deals</span>
                </label>
              </div>

              <button type="submit" className="submit-button" disabled={loading}>
                {loading ? 'Submitting...' : 'Pre-Save'}
                {!loading && (
                  <svg className="arrow-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                )}
              </button>
            </form>
          )}
        </div>
      </div>

      {/* Terms and Conditions Modal */}
      {showTermsModal && (
        <div className="modal-overlay" onClick={() => setShowTermsModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Terms & Conditions</h2>
              <button 
                className="modal-close" 
                onClick={() => setShowTermsModal(false)}
              >
                ✕
              </button>
            </div>
            <div className="modal-body">
              <h3>TERMS OF SERVICE & PRIVACY NOTICE</h3>
              <p><strong>Last updated: 21/11/2025</strong></p>
              
              <p>These Terms of Service ("Terms") and Privacy Notice ("Notice") explain how Soave B.V. ("Soave") and Samplesphere ("Samplesphere") process your personal data in connection with the Soave Producer Community and related promotional activities, including the daily-sample campaign.</p>
              
              <p>By submitting your information through the sign-up form hosted by Samplesphere, you acknowledge that you have read and understood these Terms and agree to them.</p>
              
              <p><strong>If you do not agree, please do not sign up.</strong></p>
              
              <h4>1. Identity of the Parties</h4>
              <p><strong>Soave B.V.</strong><br/>
              Wijnstraat 96 F<br/>
              3011 TR Rotterdam<br/>
              The Netherlands<br/>
              hello@soaverecords.com</p>
              
              <p><strong>Samplesphere</strong><br/>
              De Beuk 40, 2912NB, Nieuwerkerk aan den IJssel<br/>
              info@samplesphere.com</p>
              
              <h4>2. Purpose of the Campaign</h4>
              <p>The campaign allows you to:</p>
              <ul>
                <li>receive daily emails containing 24-hour download links to exclusive samples;</li>
                <li>join Soave's Producer Community;</li>
                <li>receive marketing communications from both Soave and Samplesphere;</li>
                <li>receive invitations to contests, events, and product releases;</li>
                <li>benefit from personalized content and advertising based on your preferences and behaviour.</li>
              </ul>
              
              <h4>3. Personal Data Processed</h4>
              <p><strong>3.1 Data Provided Directly by You</strong></p>
              <ul>
                <li>Name</li>
                <li>Email address</li>
                <li>LabelRadar or Spotify profile links</li>
                <li>Genre and sub-genre preferences</li>
                <li>Social media links (Instagram, Facebook, SoundCloud, YouTube, TikTok, Twitch, Discord)</li>
                <li>Country or location</li>
                <li>Artist profile images</li>
                <li>Full LabelRadar profile data (if provided)</li>
              </ul>
              
              <p><strong>3.2 Data Collected Automatically (Cookies, Pixels, Tracking)</strong></p>
              <ul>
                <li>IP address</li>
                <li>Location derived from IP</li>
                <li>Browser type/version</li>
                <li>Device information</li>
                <li>Pages visited and time spent</li>
                <li>Source/referrer</li>
                <li>Cookie identifiers and similar technologies</li>
              </ul>
              
              <p>Tracking tools include:</p>
              <ul>
                <li>Reddit Pixel</li>
                <li>Meta (Facebook/Instagram) Pixel</li>
                <li>Session/analytics cookies</li>
              </ul>
              
              <h4>4. Purposes and Legal Bases for Processing</h4>
              <p><strong>4.1 Consent</strong></p>
              <p>We process your data for:</p>
              <ul>
                <li>sending marketing emails from Soave</li>
                <li>sending marketing emails from Samplesphere</li>
                <li>delivering daily sample packs</li>
                <li>targeted advertising (Meta/Reddit custom audiences)</li>
                <li>behaviour-based analytics and retargeting</li>
                <li>using cookies/pixels for tracking and marketing</li>
                <li>collecting full LabelRadar profile data</li>
              </ul>
              
              <p>You may withdraw your consent at any time (see Section 10).</p>
              
              <p><strong>4.2 Legitimate Interests</strong></p>
              <p>We process your data to:</p>
              <ul>
                <li>maintain and improve our platforms</li>
                <li>ensure cybersecurity and fraud prevention</li>
                <li>measure campaign effectiveness</li>
                <li>perform aggregated analytics</li>
              </ul>
              
              <p>Our legitimate interests do not override your rights and freedoms. You may object to such processing.</p>
              
              <h4>5. Marketing Communications</h4>
              <p>By signing up:</p>
              <ul>
                <li>you will receive communications from both Soave and Samplesphere;</li>
                <li>you understand that these are separate marketing lists with independent unsubscribe options;</li>
                <li>unsubscribing from one does not automatically unsubscribe you from the other.</li>
              </ul>
              
              <h4>6. Recipients of Personal Data</h4>
              <p><strong>6.1 Technical Processors</strong></p>
              <p>Processed strictly under Article 28 GDPR:</p>
              <ul>
                <li>AWS SES – email delivery</li>
                <li>MongoDB – encrypted data storage</li>
                <li>AWS – cloud infrastructure</li>
                <li>Railway – hosting services</li>
              </ul>
              
              <p><strong>6.2 Advertising and Analytics Providers</strong></p>
              <p>Under your consent:</p>
              <ul>
                <li>Reddit (Reddit Pixel)</li>
                <li>Meta (Facebook/Instagram Pixel)</li>
              </ul>
              
              <p>We do not sell personal data.</p>
              
              <p><strong>6.3 LabelRadar Uploaders</strong></p>
              <p>If you previously submitted a demo to LabelRadar, and provided marketing consent, your existing data may be used for this campaign.</p>
              
              <h4>7. International Data Transfers</h4>
              <p>If any data is transferred outside the EEA (e.g., to the United States for infrastructure or advertising platforms), this is done using:</p>
              <ul>
                <li>the European Commission Standard Contractual Clauses (SCCs), and</li>
                <li>supplementary measures where required.</li>
              </ul>
              <p>You may request a copy of the relevant safeguards.</p>
              
              <h4>8. Cookies & Tracking Technologies</h4>
              <p>We use cookies for:</p>
              <p><strong>8.1 Essential Purposes</strong> – Necessary for website functionality.</p>
              <p><strong>8.2 Analytics & Performance</strong> – Measuring usage and improving services.</p>
              <p><strong>8.3 Marketing & Retargeting</strong> – Meta and Reddit Pixels for audience building, behavioural analysis, conversion tracking.</p>
              
              <p>Your explicit consent is required before placing any non-essential cookies or pixels. You may withdraw consent at any time or change cookie preferences through your browser.</p>
              
              <h4>9. Data Retention</h4>
              <p>We retain personal data only as long as necessary for delivering samples, community membership, marketing, analytics, advertising, and legal compliance.</p>
              <ul>
                <li>Marketing data: until you withdraw consent</li>
                <li>Cookie/pixel data: according to the cookie provider's policies</li>
                <li>Server logs: up to 12 months</li>
              </ul>
              <p>Data may be anonymised for statistical purposes.</p>
              
              <h4>10. Your Rights</h4>
              <p>You have the right to:</p>
              <ul>
                <li>access your personal data</li>
                <li>rectify inaccurate data</li>
                <li>erase your data ("right to be forgotten")</li>
                <li>withdraw consent at any time</li>
                <li>object to marketing and legitimate-interest processing</li>
                <li>restrict processing in certain cases</li>
                <li>data portability (obtain a copy in machine-readable form)</li>
                <li>lodge a complaint with a supervisory authority (Netherlands: Autoriteit Persoonsgegevens)</li>
              </ul>
              <p>To exercise rights, contact: info@samplesphere.com</p>
              
              <h4>11. Children</h4>
              <p>The services are not intended for individuals under 16 years old. We do not knowingly collect children's data.</p>
              
              <h4>12. Security Measures</h4>
              <p>We use appropriate technical and organisational measures including encrypted storage, secured cloud hosting, access control, monitoring, and vulnerability assessments.</p>
              <p>No system is completely secure.</p>
              
              <h4>13. Changes to These Terms</h4>
              <p>We may update these Terms and/or Notice from time to time. Significant changes will be communicated via email or posted on the registration page.</p>
              
              <h4>14. Contact</h4>
              <p><strong>Soave</strong><br/>
              Email: hello@soaverecords.com</p>
              
              <p>For questions or requests regarding these Terms or Notice:</p>
              <p><strong>Samplesphere</strong><br/>
              Email: info@samplesphere.com</p>
            </div>
            <div className="modal-footer">
              <button 
                className="modal-close-button" 
                onClick={() => setShowTermsModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EAPreSavePage;
